import { Component, HostListener, Input } from '@angular/core';

import { TotaraMenuSection } from '../../../modules/shared/models/totara-menu.model';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false
})
export class HeaderComponent {
  @Input() isMenuLoading: boolean;
  @Input() menuData: TotaraMenuSection[];

  menuShown = false;

  toggleMenu(show?: boolean): void {
    if (!this.menuData || this.menuData.length === 0) {
      return;
    }

    if (show != null) {
      this.menuShown = show;
      return;
    }

    this.menuShown = !this.menuShown;
  }
}
